module.exports = __webpack_public_path__ + "app/components/filter/principal-select-bsk7eFH7.html";